<script setup>
defineProps({
  type: {
    type: String,
    required: true
  }
})
</script>

<template>
  <v-alert type="warning" density="comfortable" class="mt-2">
    Please
    <v-btn
      size="small"
      variant="outlined"
      prepend-icon="mdi-upload"
      class="mx-1"
      color="white"
      @click="$emit('import')"
    >
      import data
    </v-btn>
    to upload the <strong> {{ type }} </strong> data. Please
    <v-btn
      size="small"
      prepend-icon="mdi-download"
      variant="outlined"
      color="white"
      class="mx-1"
      @click="$emit('download')"
    >
      Template
    </v-btn>
    the template when required.
  </v-alert>
</template>
